import { createContext, useCallback, useState } from 'react';
export const StepValidationContext = createContext(0);
export const useStepValidation = (initialValue = 0) => {
    const [stepValidation, setStepValidation] = useState(initialValue);
    const triggerStepValidation = useCallback(() => {
        setStepValidation((val) => val + 1);
    }, [setStepValidation]);
    const resetStepValidation = useCallback(() => {
        setStepValidation(initialValue);
    }, [setStepValidation, initialValue]);
    return { stepValidation, triggerStepValidation, resetStepValidation };
};
